<template>
  <div class="BottomBar" v-if="!notDisplay">
    <div class="info">
      <div class="main">
        <div class="title fs18">{{main.title}}</div>
        <div class="item line" v-for="value in main.info">
          <div class="value" @click="nav(value.link)">{{value.name}}</div>
        </div>
      </div>

      <div class="support">
        <div class="title fs18">{{support.title}}</div>
        <div class="item line" v-for="value in support.info">
          <div class="value">{{value}}</div>
        </div>
      </div>
      <div class="contact">
        <div class="title fs18">{{contact.title}}</div>
        <div class="item line" v-for="(value, key) in contact.info">
          <div class="key">{{key}}：</div>
          <div class="value">{{value}}</div>
        </div>
      </div>
      <div class="follow">
        <div class="title fs18">关注我们</div>
      <div class="share">
        <div class="item line icons">
          <share_icon class="weixin" :icon="'weixin'" @mouseover.native="hoverd='weixin'" @mouseout.native="hoverd=''"></share_icon>
          <img :src="biliIcon" @click="nav(bilibili)" />
          <!-- <share_icon class="tiktok" :icon="'tiktok'" ></share_icon>
               <share_icon class="zhihu" :icon="'zhihu'" ></share_icon> -->
        </div>
        <div class="panel">
        <div class="flexh" v-if="hoverd =='weixin'">
          <my_iwd :src="imgcoco.src" :desc="imgcoco.desc" :width="imgcoco.width" :descStyle="imgcoco.descStyle"></my_iwd>
          <my_iwd :src="imgccid.src" :desc="imgccid.desc" :width="imgccid.width" :descStyle="imgccid.descStyle"></my_iwd>
</div>
        </div>
      </div>
      </div>
      <!-- <div class="wechatOA flexh">
           </div> -->
    </div>
    <div class="copyright fs14">
      <div>
      {{copyright}}
      </div>
      <div class="space"></div>
      <div>京ICP备19012263号-16</div>
      <div class="space"></div>
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802032237" style="display:inline-block;text-decoration:none;"><div style="margin-left: 4px;color:#939393;">京公网安备 11010802032237号</div></a>
    </div>
  </div>
</template>

<script>
 import ShareIcon from '@/components/ShareIcon.vue';
 import MyIWD from '@/components/ImageWithDesc.vue';
 import BiliIcon from '@/assets/logo/CN_bilibili B.png';
 export default {
   name: 'BottomBar',
   data () {
     return {
       panel: false,
       hoverd: '',
     }
   },
   methods: {
     nav(link) {
       window.open(link, '_blank');
     },
  },
   computed: {
     notDisplay () {
       return this.$store.state.noFooter
     },
     bilibili () {
       return 'https://space.bilibili.com/470975161/'
     },
     biliIcon (){
       return BiliIcon

     },
     imgcoco () {
       return     {
         src: '/oss/images/bottombar/coco-qr.png',
         desc: '老师请扫',
         picStyle: {width: '5vw'},
         descStyle: {
           'margin-top': 0,
           color: '#3C3C3C',
           'font-size': '0.73vw'
         }
       }
     },
     imgccid () {
       return     {
         src: '/oss/images/bottombar/xuetang-qr.jpeg',
         desc: '家长请扫',
         picStyle: {width: '5vw'},
         descStyle: {
           'margin-top': 0,
           color: '#3C3C3C',
           'font-size': '0.73vw'
         }
       }
     },
 
     copyright () {
       return this.$store.state.copyright
     },
     main (){
       return this.$store.state.footer.main
     },
     support (){
       return this.$store.state.footer.support
     },
     contact (){
       return this.$store.state.footer.contact
     },
   },
   mounted (){
     /* this.$http.get('/api/footer')
      *     .then(res => {
      *       this.main = res.data.main;
      *       this.support = res.data.support;
      *       this.contact = res.data.contact;
      *     })*/
   },
   components:{
     my_iwd: MyIWD,
     share_icon: ShareIcon
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .BottomBar{
   height: 16.47vw;
   background-color: #f8f8f8;
   box-sizing: border-box;
   padding-top: 2.7vw;
   padding-left: 16.75vw;
   padding-bottom: 0.46vw;
   padding-right: 16.75vw;
   display:flex;
   flex-direction: column;
   justify-content: space-between;
   align-items:center;
 }
 .info{
   display: flex;
   width: 100%;
   align-items: flex-start;
   justify-content: space-between;
 }
 .contact, .main, .support, .follow{
   display: flex;
   flex-direction: column;
   align-items:flex-start;
   justify-content: space-between;
 }
 .item{
   display: flex;
 }
 .line{
   margin-top: 0.5vw;
   margin-bottom: 0.5vw;
 }
 .title{
   color: #3B426B;
   margin-bottom: 0.4vw;
 }
 .key{
   color: #7F8191;
   font-size: .73vw;
 }
 .value{
   color: #3B426B;
   font-size: .73vw;
 }
 .copyright{
   color: #6F6F6F;
   display: flex;
   align-items:center;
 }
 .copyright .space{
   width: 1.5em;
 }
 .flexh{
   display: flex;
   align-items: flex-start;
   justify-content: space-between;
 }
 .flexv{
   display: flex;
   flex-direction: column;
   align-items: flex-start;
 }
 .support{
   /* width: 26.6vw; */
 }
 .main .value{
   cursor: pointer;
 }
 .support .item{
   width: 100%;
   justify-content: space-between !important;
 }
 .share{
   font-size: 40px;
   position: relative;
   display: flex;
   flex-direction: column;
   align-items:center;
   justify-content: center;
 }
 .share .icons{
   width: 8vw;
   display: flex;
   justify-content:space-between;
 }
 .share .icons img{
   margin-top: -10px;
   width: 50px;
   cursor: pointer;
 }
 .panel{
   position: absolute;
   top: 3vw;
 }
 .panel>div{
   /* width: 9vw; */
 }
 /* 
    .weixin:hover ~ .panel {
    display: flex;
    }


    .tiktok:hover ~ .panel {
    display: flex; */
 /* }
    .zhihu:hover ~ .panel{
    display: flex; */

 /* } */
</style>
